<template>
  <div class="custom-select">
    <div class="title">{{ selectedValueComp.title }}</div>

    <div class="append-icon">
      <arrow-icon :color="tonal.gray[200]" :width="'16px'" />
    </div>

    <select
      :value="selectedValueComp.value"
      @focus="onFocus"
      @blur="onBlur"
      @change="handleSelected"
    >
      <option
        v-for="(option, index) in filteredOptions"
        :key="index"
        :value="option.value"
      >
        {{ option.title }}
      </option>
    </select>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue'
  import { tonal } from '@/constants/tonal'

  import { ArrowIcon } from '@/components/Icons'

  const props = defineProps({
    options: {
      type: Object,
      default: () => {},
    },
    selectedValue: {
      type: String,
    },
  })
  const emit = defineEmits(['change'])

  const isFirst = ref(false)
  const isSelected = ref(false)

  const filterKey = computed(() => props.options?.key)
  const filteredOptions = computed(() => props.options.itemList || [])
  const selectedValueComp = computed(() => {
    const defaultValue = props.options._default
    return props.options.itemList.find(
      (item) => item.value === (props.selectedValue ?? defaultValue),
    )
  })

  const handleSelected = async (event) => {
    if (event) {
      emit('change', { key: filterKey.value, value: event.target.value })
    }
  }

  const onFocus = () => {
    if (!isSelected.value) return
    if (!isFirst.value) isFirst.value = true

    isSelected.value = true
  }

  const onBlur = () => {
    if (isSelected.value) return

    isSelected.value = false
  }
</script>

<script>
  export default {
    name: 'SideFilter',
  }
</script>

<style lang="scss" scoped>
  .custom-select {
    position: relative;
    height: 24px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 4px;

    .title {
      font-size: 16px;
      line-height: 24px;
    }

    .append-icon {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    select {
      appearance: none;
      -webkit-appearance: none;
      border: unset;
      outline: none;
      background-color: transparent;
      padding: 0;
      position: absolute;
      min-width: 65px;
      height: 100%;
      right: 0;
      top: 0;
      opacity: 0;
      cursor: pointer;
    }
  }
</style>
